import { createSlice } from "@reduxjs/toolkit";
import ApiClient from "../../../utils/api/ApiClient";

const initialState = {loading:true, list:[], page:0, totalPages:0, totalElements:0 };
const clipArtSlice = createSlice({
    name:'picture/clipart',
    initialState,
    reducers:{
        loading:(state)=>{
            state.loading = true;
            state.message = null;
        },
        fetch:(state, action)=>{
            if(action.payload.page===0){
                return {...state, loading:false, ...action.payload};
            }
            return { ...state, ...action.payload,
                list: [...state.list, ...action.payload.list],
                loading:false,
            };
        }
    }
});
const clipArtActions = clipArtSlice.actions;
export default clipArtSlice.reducer;


export function fetchClipArt(categoryCode, keyword, page=0)
{
    return function(dispatch){
        dispatch( clipArtActions.loading(page) );
		const { promise } = ApiClient({
			url:`/api/clipart/list?categoryCode=${categoryCode}&keyword=${encodeURI(keyword)}&page=${page}`,
			authToken:sessionStorage.getItem('user')
		})
        
        promise.then(res=>{

			dispatch( clipArtActions.fetch(res.data) );
		}).catch( (err)=>{
            console.log('err', err)
		});
	
    }// return
}//end
